import type { FeedbackMessages } from './en';

const vi: FeedbackMessages = {
  qualified: {
    title: 'Cảm ơn bạn đã hoàn thành khảo sát này!',
    body1: 'Bạn có thể đóng cửa sổ trình duyệt này.',
    body2: 'Chúng tôi hy vọng sẽ sớm gặp lại bạn.',
    refCode: 'Mã tham chiếu: {code}',
  },
  quotaFull: {
    title: 'Khảo sát này đã đóng',
    body1: 'Cảm ơn bạn đã quan tâm đến khảo sát của chúng tôi.',
    body2: 'Rất tiếc, chúng tôi đã nhận được đủ số lượng phản hồi cần thiết.',
    body3:
      'Chúng tôi hy vọng sẽ được gặp bạn trong một trong những khảo sát sắp tới của chúng tôi!',
    refCode: 'Mã tham chiếu: {code}',
  },
  terminated: {
    title: 'Cảm ơn bạn đã chia sẻ ý kiến phản hồi!',
    body1:
      'Chúng tôi hy vọng sẽ sớm gặp lại bạn trong các khảo sát sắp tới. Trước mắt, chúc bạn một ngày tốt lành.',
    body2: 'Vui lòng đóng cửa sổ trình duyệt này.',
    refCode: 'Mã tham chiếu: {code}',
  },
  mismatch: {
    title: 'Cảm ơn sự quan tâm của bạn',
    body1: 'Rất tiếc, bạn không thuộc nhóm đối tượng mục tiêu của khảo sát này.',
    body2: 'Bạn có thể đóng trang này.',
    code: 'Mã: {code}',
  },
  error: {
    title: 'Chúng tôi không thể xử lý yêu cầu của bạn',
    linkProblemDetailed:
      'Đường liên kết bạn vừa truy cập đang gặp vấn đề. Vui lòng kiểm tra xem đường liên kết trên thanh địa chỉ có khớp với đường liên kết đã được cung cấp cho bạn không, rồi thử lại.',
    linkProblemGeneric:
      'Đường liên kết bạn vừa truy cập đang gặp vấn đề. Vui lòng thử lại.',
    contactPerson:
      'Nếu vấn đề vẫn tiếp diễn, vui lòng thông báo cho người đã gửi đường liên kết này cho bạn về sự việc này.',
    errorCode: 'Mã lỗi: {code}',
  },
};

export default vi;
